<template>
  <CardWithTitle
    :request-status="requestStatus"
    :item-id="itemId"
    :options-data="baseCardOptions"
    @call-option-menu="callOptionMenu"
    @reload="reload"
  >
    <v-row
      v-if="hasPost"
      class="post-container no-gutters"
    >
      <v-col
        v-for="post in posts"
        :key="post._id"
        class="mb-3"
        cols="12"
      >
        <MiniPost :post="post" />
      </v-col>
    </v-row>
    <h2
      v-else
      class="no-post-title pt-16"
    >
      {{ noPostsLabel }}
    </h2>

    <template #top-right-slot>
      <Badge
        v-if="hasFilterApplied && isEditor"
        type="info"
        :tooltip="$t('components.Badge.label.tooltip.info')"
        :value="$t('components.Badge.label.icon.key')"
        :preset="true"
      />
    </template>
  </CardWithTitle>
</template>

<script>
import { mapActions } from 'vuex';
import CardWithTitle from '@/components/cards/models/CardWithTitle';
import proprietaryModel from '@/mixins/proprietary-model';
import cardsModel from '@/mixins/cards-model';
import MiniPost from '@/components/cards/models/MiniPost';
import EventBus from '@/utils/event-bus';
import Badge from '@/components/Badge';

export default {
  name: 'TimelineProprietaryPosts',
  components: {
    CardWithTitle,
    MiniPost,
    Badge,
  },
  mixins: [
    proprietaryModel,
    cardsModel,
  ],
  props: {
    title: {
      type: String,
      default: '',
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      posts: [],
      requestStatus: 'loading',
      noPostsLabel: 'Nenhuma publicação encontrada',
      maxPostChar: 120,
    };
  },
  computed: {
    hasPost() {
      return this.posts && this.posts.length;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getWarroomService',
    ]),
    reload() {
      this.getData();
    },
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getWarroomService({
        itemId: this.itemId,
        servicePath: 'topPosts',
        serviceParams: {
          limit: 10,
          order_by: 'date_desc',
        },
      })
        .then(response => {
          this.posts = response.posts;
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>

<style scoped lang="scss">
  .no-post-title {
    font-size: 18px;
    text-align: center;
    color: white;
  }

  .post-container {
    height: 100%;
    width: 100%;
    overflow: auto;
  }
</style>
